import React, { Component } from 'react';
import { Grid, Cell, Card, CardTitle, CardText } from 'react-mdl';

export default class Giving extends Component {
  render() {
    let leaflet = 'https://res.sccc.org.uk/docs/mandarin-camp-2026-02-20.png';
    let InLineLeaflet =  <a href={leaflet}><img src={leaflet} alt="leaflet" style={{margin:"auto", padding:"10px", width:"75%"}}/></a>
    
    let leaflet2 = 'https://res.sccc.org.uk/docs/ccf-yaf-2026-02-20.png';
    let InLineLeaflet2 =  <a href={leaflet2}><img src={leaflet2} alt="leaflet" style={{margin:"auto", padding:"10px", width:"75%"}}/></a>
    
    let leaflet3 = 'https://res.sccc.org.uk/docs/youth-camp-2026-03-31.png';
    let InLineLeaflet3 =  <a href={leaflet3}><img src={leaflet3} alt="leaflet" style={{margin:"auto", padding:"10px", width:"75%"}}/></a>
    
    return (
      <div>
        <div style={{height: '225px', background: 'url(/images/we-are-one-body-in-Christ.jpg) center / cover'}}/>
        <div style={{width: '90%', margin: 'auto'}}>

          <Grid>

            <Cell col={12}>
              <Card shadow={0} style={{width: '100%', margin: 'auto'}}>
                <CardTitle style={{background: 'url(/images/blue_circle.jpg) center / cover'}}>SCCC Mandarin Camp' 26</CardTitle>
                <CardText>
                  <h5 style={{textAlign: 'left'}}>
                  <li>國語營會主題: 《迎接新春，领受异象》- 《迎接新春，領受異象》</li>
                   <li>Speaker: Pastor Grace Liu</li>
                   <li>日 期: 20th - 22nd February, 2026</li>
                   <li>地 點: COCM - 2 Padstow Avenue, Fishermead, Milton Keynes, MK6 2ES</li>
                  <br/> <li>Scan QR Code to Register Now !</li> <br/>
                  <a href={leaflet}>Download leaflet !</a>
                  <br/>{InLineLeaflet}
                  <br/> <br/>
                </h5>
                </CardText>
              </Card>
            </Cell>

            <Cell col={12}>
              <Card shadow={0} style={{width: '100%', margin: 'auto'}}>
                <CardTitle style={{background: 'url(/images/blue_circle.jpg) center / cover'}}>CCF/YAF Weekend Away</CardTitle>
                <CardText>
                  <h5 style={{textAlign: 'left'}}>
                  <li>CCF/YAF Weekend Away Theme： Love? or just Duty?</li>
                   <li>When: 20th - 22nd February, 2026</li>
                   <li>Where: Hill House Christian Centre, Otterhampton, Bridgwater, TA5 2PT</li>
                  <br/>  <li>Scan QR Code to Register Now !</li> <br/>
                  <a href={leaflet2}>Download leaflet !</a>
                  <br/>{InLineLeaflet2}
                  <br/> <br/>
                </h5>
                </CardText>
              </Card>
            </Cell>
           
             <Cell col={12}>
              <Card shadow={0} style={{width: '100%', margin: 'auto'}}>
                <CardTitle style={{background: 'url(/images/blue_circle.jpg) center / cover'}}>Youth Easter Camp 2026</CardTitle>
                <CardText>
                  <h5 style={{textAlign: 'left'}}>
                  <li>Youth Easter Camp Theme ： FACE2FAITH - connect mode on!</li>
                  <li>Speaker: Pastor Gavin Li</li>
                   <li>When: 31/3 ~ 2/4 2026</li>
                   <li>Where: Ferny Crofts Scout Activity Centre, Beaulieu Raod, Brockenhurst SO42 7YQ</li>
                  <br/>  <li>Scan QR Code to Register Now !</li> <br/>
                  <a href={leaflet3}>Download leaflet !</a>
                  <br/>{InLineLeaflet3}
                  <br/> <br/>
                </h5>
                </CardText>
              </Card>
            </Cell>
          </Grid>
        </div>
      </div>
    );
  }
}
